import { Autocomplete, Grid, TextField, Button, Box } from "@mui/material";
import { useBasePath } from "components/Providers";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSelectedCourseSession, setSelectedStudent, setSelectedTerm } from "store/academic/course-session";

export default function GradeFilter({ courseSessionList, selectedCourseSession, studentList, academicYear, selectedTerm, selectedStudent, }) {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const baseUrl = useBasePath();
    const markingPeriods = academicYear?.markingPeriods || []
    const dispatch = useDispatch();

    const handleClick = () => {
        navigate(`/${baseUrl}/${selectedStudent?.id}`)
    }

    return (
        <Box width='100%' display='flex' >
            <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={4}>
                    <Autocomplete
                        value={selectedCourseSession}
                        onChange={(event, newValue) => {
                            dispatch(setSelectedCourseSession(newValue));
                        }}
                        options={courseSessionList || []}
                        getOptionLabel={(option) => option?.name || ''}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                label={t("Course Session")}
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Autocomplete
                        value={selectedStudent}
                        onChange={(event, newValue) => {
                            dispatch(setSelectedStudent(newValue));
                        }}
                        options={studentList || []}
                        getOptionLabel={(option) =>
                            option?.schoolEnrollment?.person?.first_name && option?.schoolEnrollment?.person?.last_name
                                ? `${option.schoolEnrollment.person.first_name} ${option.schoolEnrollment.person.last_name}`
                                : ''
                        }
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                label={t("Select Students")}
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                        value={selectedTerm}
                        onChange={(event, newValue) => {
                            dispatch(setSelectedTerm(newValue));
                        }}
                        options={markingPeriods || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                label={t("Select Marking Period")}
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                    <Button fullWidth variant="contained" color="primary" onClick={handleClick} disabled={!selectedStudent}>{t("More")}</Button>
                </Grid>
            </Grid>
        </Box>
    )
}